module.exports = __webpack_public_path__ + "static/media/logo-pindobacu.ea8896a4.png";